import { Component, type ErrorInfo, type ReactNode } from "react";

// Red de seguridad para toda la app: sin esto, cualquier error al renderizar (p.ej. acceder a
// una propiedad de algo que resulta null) deja la pantalla completamente en blanco y sin ninguna
// pista de qué ha pasado — ni para el usuario ni para quien intente depurarlo luego a partir de
// una captura de pantalla.
interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Error no controlado en la interfaz:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink-50 p-6 text-center">
          <p className="text-lg font-semibold text-ink-900">Algo ha ido mal al cargar esta pantalla.</p>
          <p className="max-w-md text-sm text-ink-400">{this.state.error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-xl bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700"
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
